import styled from 'styled-components';
import {
    FormWrapper,
    ContainerStyled
} from '../../containers/DefaultStyles/AssessmentDetails';
import { Body } from '../../containers/DefaultStyles/Details';
import { getImageUrl } from '../../utils/imageLoading';

import { isPortrait } from '../../utils/size';

export const volunteerMatchLogoURL = getImageUrl('volunteermatch.png');

export const ScrollBody = styled(Body)``;

export const Container = styled(ContainerStyled)`
    margin-left: 0;
    margin-right: 0;
    margin-bottom: 0;
`;

export const VolunteerFormWrapper = styled(FormWrapper)`
    width: 100%;
`;

export const FormHeader = styled.header`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`;

export const Title = styled.h1`
    margin: 0;
    font-size: 24px;
    line-height: 1.33;
    font-weight: 300;
`;

export const ParentOrg = styled.h3`
    margin: 0;
    margin-bottom: 5px;
    font-size: 12px;
    line-height: 1.33;
    font-weight: 800;
    text-transform: uppercase;
    color: #000000;
`;

export const About = styled.p`
    margin: 0;
    margin-top: 6px;
    font-size: 11px;
    line-height: 1.33;
    font-weight: 800;
    text-transform: uppercase;
`;

export const Step = styled.p`
    font-size: 10px;
    color: #333333;
    font-weight: 300;
    text-transform: uppercase;
`;

export const Description = styled.p`
    margin: 5px 0;
    font-size: 14px;
    line-height: 1.33;
    font-weight: 400;
    overflow-y: ${props =>
        props.isExpanded || !props.isLongDescription ? `scroll` : `hidden`};
    overflow-x: hidden;
    flex: 1;

    &::-webkit-scrollbar {
        width: 4px;
        border-radius: 2px;
    }

    &::-webkit-scrollbar-thumb {
        border-radius: 2px;
        background: #ff245e;
    }
`;

export const PBVM = styled.span`
    cursor: pointer;
    color: #ff245e;
    font-size: 9px;
    padding-bottom: ${() => (isPortrait() ? 11 : 14)}px;
`;

export const PBVMFooter = styled(PBVM)`
    ${props => (props.sequenceFromDetailsCard ? `display: none;` : ``)};
    position: absolute;
    bottom: ${() => (isPortrait() ? 30 : 0)}px;
    z-index: 1;
    left: 50%;
    transform: translatex(-50%);
`;

export const ChangeLocationLink = styled.a`
    font-family: Lato;
    font-size: 0.625em;
    line-height: 1.6;
    color: #008eff;
    white-space: nowrap;
    cursor: pointer;
    margin-right: ${props =>
        !props.isActionChoice ? 0 : isPortrait() ? 20 : 190}px !important;
    padding: 0 !important;
`;
